import React,{Component} from 'react';
import "./style.less"
import {NavBar,Modal,Toast} from "antd-mobile";
import QRCode from 'qrcode.react';
import {connect} from "react-redux";
import {weiChatAuthor} from "../../../config/config";

const topImg = require('../../../common/image/top-img.png');
const ewmImg = require('../../../common/image/ewmimg.png');
@connect(
    state => ({userInfo: state.userInfo}),
)
export default class Share extends Component{
    constructor(props) {
        super(props);
        this.state={
            url:""
        }
    }
    componentDidMount() {
        // if (this.props.userInfo.isLoggedIn) {
        //     this.setState({
        //         // url: `https://cema99.com/inviteAdd/${this.props.match.params.userId}`
        //         url: `https://cema99.com/inviteAdd/${this.props.userInfo.userId}`
        //     });
        // }else{
        //     window.location.href = weiChatAuthor(1);
        // }

    }
    render(){
        return(
            <div className="share">
                <NavBar
                    className="navBar"
                    mode="light"
                    icon={<i className="icon iconfont iconfanhui" onClick={() => this.props.history.goBack()} />}
                >推荐有礼</NavBar>
                <div className="warp">
                    <div className="con">
                        <img src={topImg} alt=""/>
                        <p className="look"  onClick={()=>this.props.history.push('/regulation')}>点击查看奖励规则<i className="icon iconfont icon-gengduo"></i></p>
                        <button onClick={() => Modal.alert('提示', '点击右上角分享给好友，好友打开长按二维码识别注册即可领取成功。', [{ text: '知道了'}])}>分享给朋友</button>
                        <p className="ewmText">————  二维码邀请  ————</p>
                        <p className="saomiao">扫描或长按识别二维码</p>
                        <div  className="qrcode" >
                            <QRCode size={170} value={this.state.url} id="myCanvas" renderAs="svg"  />
                            <img src={ewmImg} className="ewmImg" alt=""/>
                            {/*<img src={imgT} alt=""/>*/}
                        </div>
                        {/*<div onClick={()=>this.props.history.push(`/inviteAdd/${this.props.match.params.userId}`)}>去分享</div>*/}
                    </div>

                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/container/member/Share/index.js